export enum SituacaoLocadosEnum {
  ATIVO = '01',
  INATIVO = '02',
}
